import React, { ReactNode, useContext } from 'react';

import { PageShellLayout, PageShell } from 'src/styles/pageLayoutStyles';
import styled from 'styled-components';
import {
  PaymentServicesComplaintPageConstants,
  CommonBundleConstants,
} from 'src/constants/ProjectConstants';
import { Section } from 'src/components/LandingPage';
import { DDMContextInjector } from 'src/integration/ddm/hydrator/DDMContextInjector';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { PAYMENTS_SERVICES_COMPLAINT_URL } from 'src/constants/UrlConstants';
import { ScrollRestoration } from 'react-router-dom';
import { DDM_SCHEMA_ID_FOR_PROGRAMS } from 'src/constants/GlobalConstants';
import { CreateCaseFormWithCaptcha } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha';
import { REPORTING_TYPE } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha/CreateCaseFormWithCaptcha';

const TrustContainer = styled.div`
  padding: 2rem 1.5rem 2.5rem 1.5rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.Lake};
`;

const SectionBlock = styled.div`
  padding-top: 0.5rem;
`;

const CreateCaseFormContainer = styled.div`
  padding: 0rem 0rem 0rem 0rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.Zircon};
`;

export const LandingPage = () => {
  const { commonBundle, paymentServicesComplaintBundle } =
    useContext(TranslationContext);

  return (
    <PageShellLayout>
      <PageShell>
        <ScrollRestoration />

        <TrustContainer>
          <Section
            header={paymentServicesComplaintBundle.getMessage(
              PaymentServicesComplaintPageConstants.TRUST_SECTION_HEADER,
            )}
          >
            <>
              <SectionBlock>
                {paymentServicesComplaintBundle.getMessage(
                  PaymentServicesComplaintPageConstants.TRUST_SECTION_MESSAGE,
                )}
              </SectionBlock>
              <SectionBlock>
                {paymentServicesComplaintBundle.formatMessage(
                  PaymentServicesComplaintPageConstants.REPORTING_OTHER_SELLER_CENTRAL_ISSUES,
                  {
                    a: (chunks: ReactNode) => (
                      <a
                        href={
                          PAYMENTS_SERVICES_COMPLAINT_URL.SELLER_SUPPORT_URL
                        }
                        target="_blank"
                      >
                        {chunks}
                      </a>
                    ),
                  },
                )}
              </SectionBlock>
              <SectionBlock>
                {paymentServicesComplaintBundle.formatMessage(
                  PaymentServicesComplaintPageConstants.REPORTING_FBA_ISSUES,
                  {
                    a: (chunks: ReactNode) => (
                      <a
                        href={PAYMENTS_SERVICES_COMPLAINT_URL.FAQ_DOWNLOAD_URL}
                        target="_blank"
                      >
                        {chunks}
                      </a>
                    ),
                  },
                )}
              </SectionBlock>
              <SectionBlock>
                {paymentServicesComplaintBundle.getMessage(
                  PaymentServicesComplaintPageConstants.REPORTING_BUYER_ISSUES,
                )}
              </SectionBlock>
              <SectionBlock>
                {paymentServicesComplaintBundle.formatMessage(
                  PaymentServicesComplaintPageConstants.TRUST_SECTION_MESSAGE_ADDITIONAL_INFORMATION,
                  {
                    a: (chunks: ReactNode) => (
                      <a
                        href={PAYMENTS_SERVICES_COMPLAINT_URL.FAQ_DOWNLOAD_URL}
                        target="_blank"
                      >
                        {chunks}
                      </a>
                    ),
                  },
                )}
              </SectionBlock>
            </>
          </Section>
        </TrustContainer>
        <CreateCaseFormContainer id="create-case-component">
          <DDMContextInjector
            schemaKey={DDM_SCHEMA_ID_FOR_PROGRAMS.PAYMENTS_SERVICES_COMPLAINT}
          >
            <CreateCaseFormWithCaptcha
              reportingType={REPORTING_TYPE.LOGGED_IN}
              allowAttachments={false}
              showReferralInfo
              successModalBody={paymentServicesComplaintBundle.getMessage(
                PaymentServicesComplaintPageConstants.REPORT_AN_ISSUE_SUCCESS_MODAL_MESSAGE,
              )}
              messages={{
                CREATE_CASE_FAILURE_MESSAGE:
                  paymentServicesComplaintBundle.getMessage(
                    PaymentServicesComplaintPageConstants.REPORT_AN_ISSUE_FAILURE_MODAL_MESSAGE,
                  ),
                CREATE_CASE_SUCCESSFUL_MODAL_HEADER:
                  paymentServicesComplaintBundle.getMessage(
                    PaymentServicesComplaintPageConstants.REPORT_AN_ISSUE_SUCCESS_MODAL_HEADER,
                  ),
                CREATE_CASE_SUCCESSFUL_MODAL_BUTTON_CLOSE_LABEL:
                  commonBundle.getMessage(
                    CommonBundleConstants.ACTION_BUTTON_LABEL_CLOSE,
                  ),
                REPORT_A_CASE_HEADER: paymentServicesComplaintBundle.getMessage(
                  PaymentServicesComplaintPageConstants.REPORT_A_CASE_FORM_HEADER,
                ),
                REPORT_A_CASE_DESCRIPTION:
                  paymentServicesComplaintBundle.getMessage(
                    PaymentServicesComplaintPageConstants.REPORT_A_CASE_DISCLAINER_FIELD_TEXT,
                  ),
                CAPTCHA_TITLE: paymentServicesComplaintBundle.getMessage(
                  PaymentServicesComplaintPageConstants.CAPTCHA_MODAL_TITLE,
                ),
              }}
            />
          </DDMContextInjector>
        </CreateCaseFormContainer>
      </PageShell>
    </PageShellLayout>
  );
};
